var map = {
	"./ADR/ExternalLoginADR": 214,
	"./ADR/ExternalLoginADR/": 214,
	"./ADR/ExternalLoginADR/index": 214,
	"./ADR/ExternalLoginADR/index.jsx": 214,
	"./Access/Group/Create": 215,
	"./Access/Group/Create/": 215,
	"./Access/Group/Create/Create-documentation.md": 842,
	"./Access/Group/Create/index": 215,
	"./Access/Group/Create/index.js": 215,
	"./Access/Group/List": 216,
	"./Access/Group/List/": 216,
	"./Access/Group/List/List-documentation.md": 862,
	"./Access/Group/List/index": 216,
	"./Access/Group/List/index.js": 216,
	"./Access/Region/Create": 218,
	"./Access/Region/Create/": 218,
	"./Access/Region/Create/Create-documentation.md": 863,
	"./Access/Region/Create/index": 218,
	"./Access/Region/Create/index.js": 218,
	"./Access/Region/List": 219,
	"./Access/Region/List/": 219,
	"./Access/Region/List/List-documentation.md": 879,
	"./Access/Region/List/index": 219,
	"./Access/Region/List/index.js": 219,
	"./Access/Role/Create": 220,
	"./Access/Role/Create/": 220,
	"./Access/Role/Create/Create-documentation.md": 893,
	"./Access/Role/Create/index": 220,
	"./Access/Role/Create/index.js": 220,
	"./Access/Role/Create/styles.css": 686,
	"./Access/Role/List": 221,
	"./Access/Role/List/": 221,
	"./Access/Role/List/List-documentation.md": 894,
	"./Access/Role/List/index": 221,
	"./Access/Role/List/index.js": 221,
	"./Access/School/Create": 222,
	"./Access/School/Create/": 222,
	"./Access/School/Create/Create-documentation.md": 895,
	"./Access/School/Create/index": 222,
	"./Access/School/Create/index.js": 222,
	"./Access/School/List": 223,
	"./Access/School/List/": 223,
	"./Access/School/List/List-documentation.md": 896,
	"./Access/School/List/index": 223,
	"./Access/School/List/index.js": 223,
	"./Access/Users/Create": 224,
	"./Access/Users/Create/": 224,
	"./Access/Users/Create/Create-documentation.md": 897,
	"./Access/Users/Create/index": 224,
	"./Access/Users/Create/index.js": 224,
	"./Access/Users/List": 400,
	"./Access/Users/List/": 400,
	"./Access/Users/List/List-documentation.md": 898,
	"./Access/Users/List/index": 400,
	"./Access/Users/List/index.js": 400,
	"./Access/Users/users.css": 687,
	"./Activity/Activity/ActivityActivity-documentation.md": 899,
	"./Activity/Activity/Allocate": 401,
	"./Activity/Activity/Allocate/": 401,
	"./Activity/Activity/Allocate/Allocate-documentation.md": 900,
	"./Activity/Activity/Allocate/index": 401,
	"./Activity/Activity/Allocate/index.js": 401,
	"./Activity/Activity/Allocate/style.css": 688,
	"./Activity/Activity/Bank": 402,
	"./Activity/Activity/Bank/": 402,
	"./Activity/Activity/Bank/Bank-documentation.md": 901,
	"./Activity/Activity/Bank/index": 402,
	"./Activity/Activity/Bank/index.jsx": 402,
	"./Activity/Activity/Correct": 225,
	"./Activity/Activity/Correct/": 225,
	"./Activity/Activity/Correct/Correct-documentation.md": 909,
	"./Activity/Activity/Correct/index": 225,
	"./Activity/Activity/Correct/index.js": 225,
	"./Activity/Activity/Correct/style.css": 910,
	"./Activity/Activity/Create": 226,
	"./Activity/Activity/Create/": 226,
	"./Activity/Activity/Create/Create-documentation.md": 924,
	"./Activity/Activity/Create/index": 226,
	"./Activity/Activity/Create/index.js": 226,
	"./Activity/Activity/Do": 228,
	"./Activity/Activity/Do/": 228,
	"./Activity/Activity/Do/Do-documentation.md": 925,
	"./Activity/Activity/Do/activityItemStatistics": 577,
	"./Activity/Activity/Do/activityItemStatistics.jsx": 577,
	"./Activity/Activity/Do/evaluationStatistics": 449,
	"./Activity/Activity/Do/evaluationStatistics.jsx": 449,
	"./Activity/Activity/Do/index": 228,
	"./Activity/Activity/Do/index.jsx": 228,
	"./Activity/Activity/Do/style.css": 530,
	"./Activity/Activity/List": 403,
	"./Activity/Activity/List/": 403,
	"./Activity/Activity/List/List-documentation.md": 926,
	"./Activity/Activity/List/index": 403,
	"./Activity/Activity/List/index.js": 403,
	"./Activity/Activity/Live": 395,
	"./Activity/Activity/Live/": 395,
	"./Activity/Activity/Live/Live-documentation.md": 975,
	"./Activity/Activity/Live/index": 395,
	"./Activity/Activity/Live/index.jsx": 395,
	"./Activity/Activity/Live/style.scss": 700,
	"./Activity/Activity/Me": 230,
	"./Activity/Activity/Me/": 230,
	"./Activity/Activity/Me/Me-documentation.md": 976,
	"./Activity/Activity/Me/index": 230,
	"./Activity/Activity/Me/index.js": 230,
	"./Activity/Activity/Me/style.css": 721,
	"./Activity/Activity/Show": 231,
	"./Activity/Activity/Show/": 231,
	"./Activity/Activity/Show/index": 231,
	"./Activity/Activity/Show/index.js": 231,
	"./Activity/Activity/TV/Report": 232,
	"./Activity/Activity/TV/Report/": 232,
	"./Activity/Activity/TV/Report/TVReport-documentation.md": 977,
	"./Activity/Activity/TV/Report/index": 232,
	"./Activity/Activity/TV/Report/index.jsx": 232,
	"./Activity/Activity/TV/Share": 233,
	"./Activity/Activity/TV/Share/": 233,
	"./Activity/Activity/TV/Share/index": 233,
	"./Activity/Activity/TV/Share/index.jsx": 233,
	"./Activity/Activity/View": 234,
	"./Activity/Activity/View/": 234,
	"./Activity/Activity/View/View-documentation.md": 978,
	"./Activity/Activity/View/index": 234,
	"./Activity/Activity/View/index.js": 234,
	"./Activity/Literarte": 235,
	"./Activity/Literarte/": 235,
	"./Activity/Literarte/Literarte-documentation.md": 979,
	"./Activity/Literarte/index": 235,
	"./Activity/Literarte/index.jsx": 235,
	"./Activity/Literarte/styles.css": 722,
	"./Activity/Trail/Activity": 236,
	"./Activity/Trail/Activity/": 236,
	"./Activity/Trail/Activity/Activity-documentation.md": 980,
	"./Activity/Trail/Activity/activityItemStatistics": 583,
	"./Activity/Trail/Activity/activityItemStatistics.jsx": 583,
	"./Activity/Trail/Activity/evaluationStatistics": 421,
	"./Activity/Trail/Activity/evaluationStatistics.jsx": 421,
	"./Activity/Trail/Activity/index": 236,
	"./Activity/Trail/Activity/index.jsx": 236,
	"./Activity/Trail/Activity/statistics": 420,
	"./Activity/Trail/Activity/statistics.jsx": 420,
	"./Activity/Trail/Activity/style.css": 536,
	"./Activity/Trail/Allocate": 237,
	"./Activity/Trail/Allocate/": 237,
	"./Activity/Trail/Allocate/Allocate-documentation.md": 981,
	"./Activity/Trail/Allocate/index": 237,
	"./Activity/Trail/Allocate/index.js": 237,
	"./Activity/Trail/Allocate/style.css": 723,
	"./Activity/Trail/Bank": 238,
	"./Activity/Trail/Bank/": 238,
	"./Activity/Trail/Bank/Bank-documentation.md": 982,
	"./Activity/Trail/Bank/index": 238,
	"./Activity/Trail/Bank/index.jsx": 238,
	"./Activity/Trail/Correct": 239,
	"./Activity/Trail/Correct/": 239,
	"./Activity/Trail/Correct/Correct-documentation.md": 983,
	"./Activity/Trail/Correct/index": 239,
	"./Activity/Trail/Correct/index.js": 239,
	"./Activity/Trail/Correct/style.css": 984,
	"./Activity/Trail/Do": 391,
	"./Activity/Trail/Do/": 391,
	"./Activity/Trail/Do/Do-documentation.md": 986,
	"./Activity/Trail/Do/index": 391,
	"./Activity/Trail/Do/index.jsx": 391,
	"./Activity/Trail/Do/style.css": 724,
	"./Activity/Trail/Edit": 240,
	"./Activity/Trail/Edit/": 240,
	"./Activity/Trail/Edit/index": 240,
	"./Activity/Trail/Edit/index.jsx": 240,
	"./Activity/Trail/Edit/style.css": 725,
	"./Activity/Trail/Grade/Send": 241,
	"./Activity/Trail/Grade/Send/": 241,
	"./Activity/Trail/Grade/Send/index": 241,
	"./Activity/Trail/Grade/Send/index.jsx": 241,
	"./Activity/Trail/Grade/Send/styles.css": 726,
	"./Activity/Trail/Grade/Show": 242,
	"./Activity/Trail/Grade/Show/": 242,
	"./Activity/Trail/Grade/Show/index": 242,
	"./Activity/Trail/Grade/Show/index.jsx": 242,
	"./Activity/Trail/List": 404,
	"./Activity/Trail/List/": 404,
	"./Activity/Trail/List/List-documentation.md": 987,
	"./Activity/Trail/List/index": 404,
	"./Activity/Trail/List/index.jsx": 404,
	"./Activity/Trail/PartialProgression/AllocateByTrail": 243,
	"./Activity/Trail/PartialProgression/AllocateByTrail/": 243,
	"./Activity/Trail/PartialProgression/AllocateByTrail/index": 243,
	"./Activity/Trail/PartialProgression/AllocateByTrail/index.jsx": 243,
	"./Activity/Trail/PartialProgression/AllocateByUser": 244,
	"./Activity/Trail/PartialProgression/AllocateByUser/": 244,
	"./Activity/Trail/PartialProgression/AllocateByUser/index": 244,
	"./Activity/Trail/PartialProgression/AllocateByUser/index.jsx": 244,
	"./Activity/Trail/PartialProgression/Bank": 245,
	"./Activity/Trail/PartialProgression/Bank/": 245,
	"./Activity/Trail/PartialProgression/Bank/index": 245,
	"./Activity/Trail/PartialProgression/Bank/index.jsx": 245,
	"./Activity/Trail/PartialProgression/Grade/Send": 246,
	"./Activity/Trail/PartialProgression/Grade/Send/": 246,
	"./Activity/Trail/PartialProgression/Grade/Send/index": 246,
	"./Activity/Trail/PartialProgression/Grade/Send/index.jsx": 246,
	"./Activity/Trail/PartialProgression/Grade/Show": 247,
	"./Activity/Trail/PartialProgression/Grade/Show/": 247,
	"./Activity/Trail/PartialProgression/Grade/Show/index": 247,
	"./Activity/Trail/PartialProgression/Grade/Show/index.jsx": 247,
	"./Activity/Trail/PartialProgression/Statistics": 248,
	"./Activity/Trail/PartialProgression/Statistics/": 248,
	"./Activity/Trail/PartialProgression/Statistics/index": 248,
	"./Activity/Trail/PartialProgression/Statistics/index.jsx": 248,
	"./Activity/Trail/Show": 249,
	"./Activity/Trail/Show/": 249,
	"./Activity/Trail/Show/Show-documentation.md": 988,
	"./Activity/Trail/Show/index": 249,
	"./Activity/Trail/Show/index.jsx": 249,
	"./Activity/Trail/Show/style.css": 727,
	"./AllocationFinder": 185,
	"./AllocationFinder/": 185,
	"./AllocationFinder/AllocationFinder-documentation.md": 989,
	"./AllocationFinder/index": 185,
	"./AllocationFinder/index.js": 185,
	"./AllocationFinder/style.css": 666,
	"./Audict/Action/Create": 250,
	"./Audict/Action/Create/": 250,
	"./Audict/Action/Create/Create-documentation.md": 990,
	"./Audict/Action/Create/index": 250,
	"./Audict/Action/Create/index.js": 250,
	"./Audict/Action/List": 251,
	"./Audict/Action/List/": 251,
	"./Audict/Action/List/List-documentation.md": 991,
	"./Audict/Action/List/index": 251,
	"./Audict/Action/List/index.js": 251,
	"./Audict/Origin/Create": 252,
	"./Audict/Origin/Create/": 252,
	"./Audict/Origin/Create/Create-documentation.md": 992,
	"./Audict/Origin/Create/index": 252,
	"./Audict/Origin/Create/index.js": 252,
	"./Audict/Origin/List": 253,
	"./Audict/Origin/List/": 253,
	"./Audict/Origin/List/List-documentation.md": 993,
	"./Audict/Origin/List/index": 253,
	"./Audict/Origin/List/index.js": 253,
	"./Banner": 254,
	"./Banner/": 254,
	"./Banner/index": 254,
	"./Banner/index.js": 254,
	"./Child": 255,
	"./Child/": 255,
	"./Child/Child-documentation.md": 994,
	"./Child/index": 255,
	"./Child/index.jsx": 255,
	"./Classification/Ability/Create": 256,
	"./Classification/Ability/Create/": 256,
	"./Classification/Ability/Create/Create-documentation.md": 995,
	"./Classification/Ability/Create/index": 256,
	"./Classification/Ability/Create/index.js": 256,
	"./Classification/Ability/List": 257,
	"./Classification/Ability/List/": 257,
	"./Classification/Ability/List/List-documentation.md": 996,
	"./Classification/Ability/List/index": 257,
	"./Classification/Ability/List/index.js": 257,
	"./Classification/DifficultyLevel/Create": 258,
	"./Classification/DifficultyLevel/Create/": 258,
	"./Classification/DifficultyLevel/Create/Create-documentation.md": 997,
	"./Classification/DifficultyLevel/Create/index": 258,
	"./Classification/DifficultyLevel/Create/index.js": 258,
	"./Classification/DifficultyLevel/List": 259,
	"./Classification/DifficultyLevel/List/": 259,
	"./Classification/DifficultyLevel/List/List-documentation.md": 998,
	"./Classification/DifficultyLevel/List/index": 259,
	"./Classification/DifficultyLevel/List/index.js": 259,
	"./Classification/Discipline/Create": 260,
	"./Classification/Discipline/Create/": 260,
	"./Classification/Discipline/Create/Create-documentation.md": 999,
	"./Classification/Discipline/Create/index": 260,
	"./Classification/Discipline/Create/index.js": 260,
	"./Classification/Discipline/List": 261,
	"./Classification/Discipline/List/": 261,
	"./Classification/Discipline/List/List-documentation.md": 1000,
	"./Classification/Discipline/List/index": 261,
	"./Classification/Discipline/List/index.js": 261,
	"./Classification/Goal/Create": 262,
	"./Classification/Goal/Create/": 262,
	"./Classification/Goal/Create/Create-documentation.md": 1001,
	"./Classification/Goal/Create/index": 262,
	"./Classification/Goal/Create/index.js": 262,
	"./Classification/Goal/List": 263,
	"./Classification/Goal/List/": 263,
	"./Classification/Goal/List/List-documentation.md": 1002,
	"./Classification/Goal/List/index": 263,
	"./Classification/Goal/List/index.js": 263,
	"./Classification/Grade/Create": 264,
	"./Classification/Grade/Create/": 264,
	"./Classification/Grade/Create/Create-documentation.md": 1003,
	"./Classification/Grade/Create/index": 264,
	"./Classification/Grade/Create/index.js": 264,
	"./Classification/Grade/List": 265,
	"./Classification/Grade/List/": 265,
	"./Classification/Grade/List/List-documentation.md": 1004,
	"./Classification/Grade/List/index": 265,
	"./Classification/Grade/List/index.js": 265,
	"./Classification/LearningArea/Create": 266,
	"./Classification/LearningArea/Create/": 266,
	"./Classification/LearningArea/Create/Create-documentation.md": 1005,
	"./Classification/LearningArea/Create/index": 266,
	"./Classification/LearningArea/Create/index.js": 266,
	"./Classification/LearningArea/List": 267,
	"./Classification/LearningArea/List/": 267,
	"./Classification/LearningArea/List/List-documentation.md": 1006,
	"./Classification/LearningArea/List/index": 267,
	"./Classification/LearningArea/List/index.js": 267,
	"./Classification/Module/Create": 268,
	"./Classification/Module/Create/": 268,
	"./Classification/Module/Create/Create-documentation.md": 1007,
	"./Classification/Module/Create/index": 268,
	"./Classification/Module/Create/index.js": 268,
	"./Classification/Module/List": 269,
	"./Classification/Module/List/": 269,
	"./Classification/Module/List/List-documentation.md": 1008,
	"./Classification/Module/List/index": 269,
	"./Classification/Module/List/index.js": 269,
	"./Classification/Segment/Create": 270,
	"./Classification/Segment/Create/": 270,
	"./Classification/Segment/Create/Create-documentation.md": 1009,
	"./Classification/Segment/Create/index": 270,
	"./Classification/Segment/Create/index.js": 270,
	"./Classification/Segment/List": 271,
	"./Classification/Segment/List/": 271,
	"./Classification/Segment/List/List-documentation.md": 1010,
	"./Classification/Segment/List/index": 271,
	"./Classification/Segment/List/index.js": 271,
	"./Classification/Source/Create": 272,
	"./Classification/Source/Create/": 272,
	"./Classification/Source/Create/Create-documentation.md": 1011,
	"./Classification/Source/Create/index": 272,
	"./Classification/Source/Create/index.js": 272,
	"./Classification/Source/List": 273,
	"./Classification/Source/List/": 273,
	"./Classification/Source/List/List-documentation.md": 1012,
	"./Classification/Source/List/index": 273,
	"./Classification/Source/List/index.js": 273,
	"./Classification/ThematicUnit/Create": 274,
	"./Classification/ThematicUnit/Create/": 274,
	"./Classification/ThematicUnit/Create/Create-documentation.md": 1013,
	"./Classification/ThematicUnit/Create/index": 274,
	"./Classification/ThematicUnit/Create/index.js": 274,
	"./Classification/ThematicUnit/List": 275,
	"./Classification/ThematicUnit/List/": 275,
	"./Classification/ThematicUnit/List/List-documentation.md": 1014,
	"./Classification/ThematicUnit/List/index": 275,
	"./Classification/ThematicUnit/List/index.js": 275,
	"./Communication/Notification/Create": 276,
	"./Communication/Notification/Create/": 276,
	"./Communication/Notification/Create/Create-documentation.md": 1015,
	"./Communication/Notification/Create/index": 276,
	"./Communication/Notification/Create/index.js": 276,
	"./Communication/Notification/Create/style.css": 728,
	"./Communication/Notification/Detail": 277,
	"./Communication/Notification/Detail/": 277,
	"./Communication/Notification/Detail/Detail-documentation.md": 1016,
	"./Communication/Notification/Detail/index": 277,
	"./Communication/Notification/Detail/index.js": 277,
	"./Communication/Notification/Detail/style.css": 729,
	"./Communication/Notification/List": 278,
	"./Communication/Notification/List/": 278,
	"./Communication/Notification/List/List-documentation.md": 1017,
	"./Communication/Notification/List/index": 278,
	"./Communication/Notification/List/index.js": 278,
	"./Communication/Notification/Me": 279,
	"./Communication/Notification/Me/": 279,
	"./Communication/Notification/Me/Me-documentation.md": 1018,
	"./Communication/Notification/Me/index": 279,
	"./Communication/Notification/Me/index.js": 279,
	"./Communication/Notification/Me/style.css": 730,
	"./Communication/Occurrence/Create": 280,
	"./Communication/Occurrence/Create/": 280,
	"./Communication/Occurrence/Create/Create-documentation.md": 1019,
	"./Communication/Occurrence/Create/index": 280,
	"./Communication/Occurrence/Create/index.js": 280,
	"./Communication/Occurrence/Detail": 281,
	"./Communication/Occurrence/Detail/": 281,
	"./Communication/Occurrence/Detail/Detail-documentation.md": 1020,
	"./Communication/Occurrence/Detail/index": 281,
	"./Communication/Occurrence/Detail/index.js": 281,
	"./Communication/Occurrence/Detail/style.css": 731,
	"./Communication/Occurrence/List": 282,
	"./Communication/Occurrence/List/": 282,
	"./Communication/Occurrence/List/List-documentation.md": 1021,
	"./Communication/Occurrence/List/index": 282,
	"./Communication/Occurrence/List/index.js": 282,
	"./Communication/Occurrence/Me": 283,
	"./Communication/Occurrence/Me/": 283,
	"./Communication/Occurrence/Me/Me-documentation.md": 1022,
	"./Communication/Occurrence/Me/index": 283,
	"./Communication/Occurrence/Me/index.js": 283,
	"./Communication/Occurrence/Me/style.css": 732,
	"./Communication/OccurrenceType/Create": 284,
	"./Communication/OccurrenceType/Create/": 284,
	"./Communication/OccurrenceType/Create/Create-documentation.md": 1023,
	"./Communication/OccurrenceType/Create/index": 284,
	"./Communication/OccurrenceType/Create/index.js": 284,
	"./Communication/OccurrenceType/List": 285,
	"./Communication/OccurrenceType/List/": 285,
	"./Communication/OccurrenceType/List/List-documentation.md": 1024,
	"./Communication/OccurrenceType/List/index": 285,
	"./Communication/OccurrenceType/List/index.js": 285,
	"./Community/Classroom/Create": 286,
	"./Community/Classroom/Create/": 286,
	"./Community/Classroom/Create/Create-documentation.md": 1025,
	"./Community/Classroom/Create/index": 286,
	"./Community/Classroom/Create/index.js": 286,
	"./Community/Classroom/Create/styles.css": 733,
	"./Community/Classroom/Jitsi": 287,
	"./Community/Classroom/Jitsi/": 287,
	"./Community/Classroom/Jitsi/Jitsi-documentation.md": 1026,
	"./Community/Classroom/Jitsi/index": 287,
	"./Community/Classroom/Jitsi/index.js": 287,
	"./Community/Classroom/Jitsi/styles.css": 734,
	"./Community/Classroom/List": 288,
	"./Community/Classroom/List/": 288,
	"./Community/Classroom/List/List-documentation.md": 1027,
	"./Community/Classroom/List/index": 288,
	"./Community/Classroom/List/index.js": 288,
	"./Community/Classroom/Me": 289,
	"./Community/Classroom/Me/": 289,
	"./Community/Classroom/Me/Me-documentation.md": 1028,
	"./Community/Classroom/Me/index": 289,
	"./Community/Classroom/Me/index.js": 289,
	"./Community/Classroom/Me/styles.css": 735,
	"./Community/Classroom/Members": 396,
	"./Community/Classroom/Members/": 396,
	"./Community/Classroom/Members/Members-documentation.md": 1029,
	"./Community/Classroom/Members/index": 396,
	"./Community/Classroom/Members/index.js": 396,
	"./Community/Classroom/Members/styles.css": 736,
	"./Community/Classroom/Migrate": 290,
	"./Community/Classroom/Migrate/": 290,
	"./Community/Classroom/Migrate/Migrate-documentation.md": 1030,
	"./Community/Classroom/Migrate/index": 290,
	"./Community/Classroom/Migrate/index.jsx": 290,
	"./Community/Classroom/Show": 291,
	"./Community/Classroom/Show/": 291,
	"./Community/Classroom/Show/Show-documentation.md": 1032,
	"./Community/Classroom/Show/index": 291,
	"./Community/Classroom/Show/index.js": 291,
	"./Community/Classroom/Show/jitsi": 471,
	"./Community/Classroom/Show/jitsi.js": 471,
	"./Community/Classroom/Show/statistics": 192,
	"./Community/Classroom/Show/statistics.jsx": 192,
	"./Community/Classroom/Show/styles.css": 537,
	"./Community/Room/Create": 292,
	"./Community/Room/Create/": 292,
	"./Community/Room/Create/Create-documentation.md": 1033,
	"./Community/Room/Create/index": 292,
	"./Community/Room/Create/index.js": 292,
	"./Community/Room/Create/users": 584,
	"./Community/Room/Create/users.js": 584,
	"./Community/Room/List": 293,
	"./Community/Room/List/": 293,
	"./Community/Room/List/List-documentation.md": 1034,
	"./Community/Room/List/index": 293,
	"./Community/Room/List/index.js": 293,
	"./Community/Room/Me": 294,
	"./Community/Room/Me/": 294,
	"./Community/Room/Me/Me-documentation.md": 1035,
	"./Community/Room/Me/index": 294,
	"./Community/Room/Me/index.js": 294,
	"./Community/Room/Me/search": 472,
	"./Community/Room/Me/search.js": 472,
	"./Community/Room/Me/styles.css": 737,
	"./Community/Room/Members": 295,
	"./Community/Room/Members/": 295,
	"./Community/Room/Members/Members-documentation.md": 1036,
	"./Community/Room/Members/index": 295,
	"./Community/Room/Members/index.js": 295,
	"./Community/Room/Show": 296,
	"./Community/Room/Show/": 296,
	"./Community/Room/Show/Show-documentation.md": 1037,
	"./Community/Room/Show/index": 296,
	"./Community/Room/Show/index.js": 296,
	"./Community/Room/Show/styles.css": 738,
	"./Configuration/ADR/CreateOrigin": 297,
	"./Configuration/ADR/CreateOrigin/": 297,
	"./Configuration/ADR/CreateOrigin/index": 297,
	"./Configuration/ADR/CreateOrigin/index.jsx": 297,
	"./Configuration/ADR/Origin": 298,
	"./Configuration/ADR/Origin/": 298,
	"./Configuration/ADR/Origin/index": 298,
	"./Configuration/ADR/Origin/index.jsx": 298,
	"./Configuration/Component/Create": 299,
	"./Configuration/Component/Create/": 299,
	"./Configuration/Component/Create/Create-documentation.md": 1038,
	"./Configuration/Component/Create/index": 299,
	"./Configuration/Component/Create/index.js": 299,
	"./Configuration/Component/List": 300,
	"./Configuration/Component/List/": 300,
	"./Configuration/Component/List/List-documentation.md": 1039,
	"./Configuration/Component/List/index": 300,
	"./Configuration/Component/List/index.js": 300,
	"./Configuration/Language/Create": 301,
	"./Configuration/Language/Create/": 301,
	"./Configuration/Language/Create/Create-documentation.md": 1040,
	"./Configuration/Language/Create/index": 301,
	"./Configuration/Language/Create/index.js": 301,
	"./Configuration/Language/List": 302,
	"./Configuration/Language/List/": 302,
	"./Configuration/Language/List/List-documentation.md": 1041,
	"./Configuration/Language/List/index": 302,
	"./Configuration/Language/List/index.js": 302,
	"./Configuration/Menu/List": 405,
	"./Configuration/Menu/List/": 405,
	"./Configuration/Menu/List/List-documentation.md": 1042,
	"./Configuration/Menu/List/index": 405,
	"./Configuration/Menu/List/index.js": 405,
	"./Configuration/Menu/List/styles.css": 739,
	"./Configuration/Module/Create": 303,
	"./Configuration/Module/Create/": 303,
	"./Configuration/Module/Create/Create-documentation.md": 1043,
	"./Configuration/Module/Create/index": 303,
	"./Configuration/Module/Create/index.js": 303,
	"./Configuration/Module/List": 304,
	"./Configuration/Module/List/": 304,
	"./Configuration/Module/List/List-documentation.md": 1044,
	"./Configuration/Module/List/index": 304,
	"./Configuration/Module/List/index.js": 304,
	"./Configuration/Role/Create": 305,
	"./Configuration/Role/Create/": 305,
	"./Configuration/Role/Create/Create-documentation.md": 1045,
	"./Configuration/Role/Create/index": 305,
	"./Configuration/Role/Create/index.js": 305,
	"./Configuration/Role/Create/styles.css": 740,
	"./Configuration/Role/List": 306,
	"./Configuration/Role/List/": 306,
	"./Configuration/Role/List/List-documentation.md": 1046,
	"./Configuration/Role/List/index": 306,
	"./Configuration/Role/List/index.js": 306,
	"./Configuration/SocialNetwork/Create": 307,
	"./Configuration/SocialNetwork/Create/": 307,
	"./Configuration/SocialNetwork/Create/Create-documentation.md": 1047,
	"./Configuration/SocialNetwork/Create/index": 307,
	"./Configuration/SocialNetwork/Create/index.js": 307,
	"./Configuration/SocialNetwork/List": 308,
	"./Configuration/SocialNetwork/List/": 308,
	"./Configuration/SocialNetwork/List/List-documentation.md": 1048,
	"./Configuration/SocialNetwork/List/index": 308,
	"./Configuration/SocialNetwork/List/index.js": 308,
	"./Configuration/Translation/Create": 309,
	"./Configuration/Translation/Create/": 309,
	"./Configuration/Translation/Create/Create-documentation.md": 1049,
	"./Configuration/Translation/Create/index": 309,
	"./Configuration/Translation/Create/index.js": 309,
	"./Configuration/Translation/List": 310,
	"./Configuration/Translation/List/": 310,
	"./Configuration/Translation/List/List-documentation.md": 1050,
	"./Configuration/Translation/List/index": 310,
	"./Configuration/Translation/List/index.js": 310,
	"./Consolidated/Panel": 311,
	"./Consolidated/Panel/": 311,
	"./Consolidated/Panel/Panel-documentation.md": 1051,
	"./Consolidated/Panel/filter": 473,
	"./Consolidated/Panel/filter.jsx": 473,
	"./Consolidated/Panel/index": 311,
	"./Consolidated/Panel/index.jsx": 311,
	"./Content/Docs/Me": 312,
	"./Content/Docs/Me/": 312,
	"./Content/Docs/Me/Me-documentation.md": 1052,
	"./Content/Docs/Me/edit": 475,
	"./Content/Docs/Me/edit.js": 475,
	"./Content/Docs/Me/folder": 477,
	"./Content/Docs/Me/folder.js": 477,
	"./Content/Docs/Me/index": 312,
	"./Content/Docs/Me/index.js": 312,
	"./Content/Docs/Me/info": 478,
	"./Content/Docs/Me/info.js": 478,
	"./Content/Docs/Me/permission": 474,
	"./Content/Docs/Me/permission.js": 474,
	"./Content/Docs/Me/style.css": 741,
	"./Content/Docs/Me/upload": 476,
	"./Content/Docs/Me/upload.js": 476,
	"./Content/HandsOn": 313,
	"./Content/HandsOn/": 313,
	"./Content/HandsOn/default.png": 593,
	"./Content/HandsOn/favorites.webp": 594,
	"./Content/HandsOn/handson.webp": 1053,
	"./Content/HandsOn/index": 313,
	"./Content/HandsOn/index.jsx": 313,
	"./Content/HandsOn/roulette.webp": 595,
	"./Content/HandsOn/styles.css": 742,
	"./Content/Library": 314,
	"./Content/Library/": 314,
	"./Content/Library/Library-documentation.md": 1054,
	"./Content/Library/index": 314,
	"./Content/Library/index.jsx": 314,
	"./Content/List": 315,
	"./Content/List/": 315,
	"./Content/List/List-documentation.md": 1055,
	"./Content/List/index": 315,
	"./Content/List/index.js": 315,
	"./Content/Lo/Create": 316,
	"./Content/Lo/Create/": 316,
	"./Content/Lo/Create/Create-documentation.md": 1056,
	"./Content/Lo/Create/index": 316,
	"./Content/Lo/Create/index.js": 316,
	"./Content/Lo/List": 317,
	"./Content/Lo/List/": 317,
	"./Content/Lo/List/List-documentation.md": 1057,
	"./Content/Lo/List/index": 317,
	"./Content/Lo/List/index.js": 317,
	"./Content/Skin/Create": 318,
	"./Content/Skin/Create/": 318,
	"./Content/Skin/Create/Create-documentation.md": 1058,
	"./Content/Skin/Create/index": 318,
	"./Content/Skin/Create/index.js": 318,
	"./Content/Skin/List": 319,
	"./Content/Skin/List/": 319,
	"./Content/Skin/List/List-documentation.md": 1059,
	"./Content/Skin/List/index": 319,
	"./Content/Skin/List/index.js": 319,
	"./Content/Type/Create": 320,
	"./Content/Type/Create/": 320,
	"./Content/Type/Create/Create-documentation.md": 1060,
	"./Content/Type/Create/index": 320,
	"./Content/Type/Create/index.js": 320,
	"./Content/Type/List": 321,
	"./Content/Type/List/": 321,
	"./Content/Type/List/List-documentation.md": 1061,
	"./Content/Type/List/index": 321,
	"./Content/Type/List/index.js": 321,
	"./Content/View": 389,
	"./Content/View/": 389,
	"./Content/View/View-documentation.md": 1062,
	"./Content/View/index": 389,
	"./Content/View/index.jsx": 389,
	"./DailyRecord/Create": 322,
	"./DailyRecord/Create/": 322,
	"./DailyRecord/Create/Create-documentation.md": 1063,
	"./DailyRecord/Create/index": 322,
	"./DailyRecord/Create/index.jsx": 322,
	"./DailyRecord/Create/style.css": 743,
	"./DailyRecord/Edit": 323,
	"./DailyRecord/Edit/": 323,
	"./DailyRecord/Edit/Edit-documentation.md": 1064,
	"./DailyRecord/Edit/index": 323,
	"./DailyRecord/Edit/index.jsx": 323,
	"./DailyRecord/Edit/style.css": 1065,
	"./DailyRecord/List": 324,
	"./DailyRecord/List/": 324,
	"./DailyRecord/List/List-documentation.md": 1066,
	"./DailyRecord/List/index": 324,
	"./DailyRecord/List/index.jsx": 324,
	"./DailyRecord/View": 325,
	"./DailyRecord/View/": 325,
	"./DailyRecord/View/View-documentation.md": 1067,
	"./DailyRecord/View/index": 325,
	"./DailyRecord/View/index.jsx": 325,
	"./Dashboard": 326,
	"./Dashboard/": 326,
	"./Dashboard/Dashboard-documentation.md": 1068,
	"./Dashboard/index": 326,
	"./Dashboard/index.js": 326,
	"./DigitalBooks/List": 327,
	"./DigitalBooks/List/": 327,
	"./DigitalBooks/List/index": 327,
	"./DigitalBooks/List/index.jsx": 327,
	"./DigitalBooks/List/styles.css": 744,
	"./Education/Curriculum/Create": 328,
	"./Education/Curriculum/Create/": 328,
	"./Education/Curriculum/Create/Create-documentation.md": 1069,
	"./Education/Curriculum/Create/index": 328,
	"./Education/Curriculum/Create/index.js": 328,
	"./Education/Curriculum/List": 329,
	"./Education/Curriculum/List/": 329,
	"./Education/Curriculum/List/List-documentation.md": 1070,
	"./Education/Curriculum/List/index": 329,
	"./Education/Curriculum/List/index.js": 329,
	"./Education/CurriculumReport": 397,
	"./Education/CurriculumReport/": 397,
	"./Education/CurriculumReport/Report-documentation.md": 1071,
	"./Education/CurriculumReport/index": 397,
	"./Education/CurriculumReport/index.jsx": 397,
	"./Education/Method/Create": 330,
	"./Education/Method/Create/": 330,
	"./Education/Method/Create/Create-documentation.md": 1072,
	"./Education/Method/Create/index": 330,
	"./Education/Method/Create/index.js": 330,
	"./Education/Method/List": 331,
	"./Education/Method/List/": 331,
	"./Education/Method/List/List-documentation.md": 1073,
	"./Education/Method/List/index": 331,
	"./Education/Method/List/index.js": 331,
	"./Education/Period/Create": 332,
	"./Education/Period/Create/": 332,
	"./Education/Period/Create/Create-documentation.md": 1074,
	"./Education/Period/Create/index": 332,
	"./Education/Period/Create/index.js": 332,
	"./Education/Period/List": 333,
	"./Education/Period/List/": 333,
	"./Education/Period/List/List-documentation.md": 1075,
	"./Education/Period/List/index": 333,
	"./Education/Period/List/index.js": 333,
	"./Education/Resource/Create": 334,
	"./Education/Resource/Create/": 334,
	"./Education/Resource/Create/Create-documentation.md": 1076,
	"./Education/Resource/Create/index": 334,
	"./Education/Resource/Create/index.js": 334,
	"./Education/Resource/List": 335,
	"./Education/Resource/List/": 335,
	"./Education/Resource/List/List-documentation.md": 1077,
	"./Education/Resource/List/index": 335,
	"./Education/Resource/List/index.js": 335,
	"./Emotions/List": 393,
	"./Emotions/List/": 393,
	"./Emotions/List/List-documentation.md": 1078,
	"./Emotions/List/index": 393,
	"./Emotions/List/index.jsx": 393,
	"./Evaluation/ADR/Allocate": 336,
	"./Evaluation/ADR/Allocate/": 336,
	"./Evaluation/ADR/Allocate/index": 336,
	"./Evaluation/ADR/Allocate/index.jsx": 336,
	"./Evaluation/ADR/Allocate/style.css": 745,
	"./Evaluation/ADR/AllocateList": 337,
	"./Evaluation/ADR/AllocateList/": 337,
	"./Evaluation/ADR/AllocateList/index": 337,
	"./Evaluation/ADR/AllocateList/index.jsx": 337,
	"./Evaluation/ADR/Bank": 338,
	"./Evaluation/ADR/Bank/": 338,
	"./Evaluation/ADR/Bank/index": 338,
	"./Evaluation/ADR/Bank/index.jsx": 338,
	"./Evaluation/ADR/Create": 339,
	"./Evaluation/ADR/Create/": 339,
	"./Evaluation/ADR/Create/index": 339,
	"./Evaluation/ADR/Create/index.js": 339,
	"./Evaluation/ADR/List": 340,
	"./Evaluation/ADR/List/": 340,
	"./Evaluation/ADR/List/index": 340,
	"./Evaluation/ADR/List/index.js": 340,
	"./Evaluation/ADR/List/statistics": 479,
	"./Evaluation/ADR/List/statistics.jsx": 479,
	"./Evaluation/ADR/List/style.css": 747,
	"./Evaluation/ADR/Report": 341,
	"./Evaluation/ADR/Report/": 341,
	"./Evaluation/ADR/Report/index": 341,
	"./Evaluation/ADR/Report/index.jsx": 341,
	"./Evaluation/ADR/Report/style.css": 748,
	"./Evaluation/ADR/Schedule": 342,
	"./Evaluation/ADR/Schedule/": 342,
	"./Evaluation/ADR/Schedule/index": 342,
	"./Evaluation/ADR/Schedule/index.jsx": 342,
	"./Evaluation/Allocate": 343,
	"./Evaluation/Allocate/": 343,
	"./Evaluation/Allocate/Allocate-documentation.md": 1079,
	"./Evaluation/Allocate/index": 343,
	"./Evaluation/Allocate/index.jsx": 343,
	"./Evaluation/Allocate/style.css": 749,
	"./Evaluation/Bank/Allocate": 344,
	"./Evaluation/Bank/Allocate/": 344,
	"./Evaluation/Bank/Allocate/index": 344,
	"./Evaluation/Bank/Allocate/index.jsx": 344,
	"./Evaluation/Bank/Allocate/style.css": 750,
	"./Evaluation/Bank/GradePanel": 406,
	"./Evaluation/Bank/GradePanel/": 406,
	"./Evaluation/Bank/GradePanel/index": 406,
	"./Evaluation/Bank/GradePanel/index.jsx": 406,
	"./Evaluation/Bank/GradePanel/styles.css": 751,
	"./Evaluation/Bank/List": 345,
	"./Evaluation/Bank/List/": 345,
	"./Evaluation/Bank/List/index": 345,
	"./Evaluation/Bank/List/index.jsx": 345,
	"./Evaluation/Bank/Statistics": 346,
	"./Evaluation/Bank/Statistics/": 346,
	"./Evaluation/Bank/Statistics/index": 346,
	"./Evaluation/Bank/Statistics/index.jsx": 346,
	"./Evaluation/Bank/StudentStatistics": 347,
	"./Evaluation/Bank/StudentStatistics/": 347,
	"./Evaluation/Bank/StudentStatistics/index": 347,
	"./Evaluation/Bank/StudentStatistics/index.jsx": 347,
	"./Evaluation/Create": 348,
	"./Evaluation/Create/": 348,
	"./Evaluation/Create/Create-documentation.md": 1080,
	"./Evaluation/Create/index": 348,
	"./Evaluation/Create/index.jsx": 348,
	"./Evaluation/List": 349,
	"./Evaluation/List/": 349,
	"./Evaluation/List/List-documentation.md": 1081,
	"./Evaluation/List/index": 349,
	"./Evaluation/List/index.js": 349,
	"./Evaluation/List/statistics": 149,
	"./Evaluation/List/statistics.jsx": 149,
	"./Evaluation/List/style.css": 746,
	"./Evaluation/Print": 350,
	"./Evaluation/Print/": 350,
	"./Evaluation/Print/Print-documentation.md": 1082,
	"./Evaluation/Print/index": 350,
	"./Evaluation/Print/index.jsx": 350,
	"./Evaluation/Question/Bank": 351,
	"./Evaluation/Question/Bank/": 351,
	"./Evaluation/Question/Bank/Bank-documentation.md": 1083,
	"./Evaluation/Question/Bank/Review/Edit": 394,
	"./Evaluation/Question/Bank/Review/Edit/": 394,
	"./Evaluation/Question/Bank/Review/Edit/index": 394,
	"./Evaluation/Question/Bank/Review/Edit/index.jsx": 394,
	"./Evaluation/Question/Bank/Review/Edit/styles.css": 753,
	"./Evaluation/Question/Bank/Review/List": 352,
	"./Evaluation/Question/Bank/Review/List/": 352,
	"./Evaluation/Question/Bank/Review/List/index": 352,
	"./Evaluation/Question/Bank/Review/List/index.jsx": 352,
	"./Evaluation/Question/Bank/index": 351,
	"./Evaluation/Question/Bank/index.jsx": 351,
	"./Evaluation/Question/Bank/styles.css": 752,
	"./Evaluation/Question/Create": 191,
	"./Evaluation/Question/Create/": 191,
	"./Evaluation/Question/Create/Create-documentation.md": 1084,
	"./Evaluation/Question/Create/index": 191,
	"./Evaluation/Question/Create/index.js": 191,
	"./Evaluation/Question/Create/styles.css": 698,
	"./Evaluation/Question/List": 353,
	"./Evaluation/Question/List/": 353,
	"./Evaluation/Question/List/List-documentation.md": 1085,
	"./Evaluation/Question/List/index": 353,
	"./Evaluation/Question/List/index.js": 353,
	"./Evaluation/Question/Prototype": 354,
	"./Evaluation/Question/Prototype/": 354,
	"./Evaluation/Question/Prototype/Prototype-documentation.md": 1086,
	"./Evaluation/Question/Prototype/index": 354,
	"./Evaluation/Question/Prototype/index.js": 354,
	"./Evaluation/QuestionList/Do": 190,
	"./Evaluation/QuestionList/Do/": 190,
	"./Evaluation/QuestionList/Do/index": 190,
	"./Evaluation/QuestionList/Do/index.js": 190,
	"./Evaluation/QuestionList/Do/styles.css": 699,
	"./Evaluation/QuestionList/List": 355,
	"./Evaluation/QuestionList/List/": 355,
	"./Evaluation/QuestionList/List/List-documentation.md": 1087,
	"./Evaluation/QuestionList/List/index": 355,
	"./Evaluation/QuestionList/List/index.js": 355,
	"./Evaluation/QuestionList/Prototype": 356,
	"./Evaluation/QuestionList/Prototype/": 356,
	"./Evaluation/QuestionList/Prototype/index": 356,
	"./Evaluation/QuestionList/Prototype/index.js": 356,
	"./Evaluation/Tv": 407,
	"./Evaluation/Tv/": 407,
	"./Evaluation/Tv/Tv-documentation.md": 1088,
	"./Evaluation/Tv/index": 407,
	"./Evaluation/Tv/index.js": 407,
	"./Evaluation/Tv/style.css": 754,
	"./Evaluation/TypeQuestion/Create": 357,
	"./Evaluation/TypeQuestion/Create/": 357,
	"./Evaluation/TypeQuestion/Create/Create-documentation.md": 1089,
	"./Evaluation/TypeQuestion/Create/index": 357,
	"./Evaluation/TypeQuestion/Create/index.js": 357,
	"./Evaluation/TypeQuestion/List": 358,
	"./Evaluation/TypeQuestion/List/": 358,
	"./Evaluation/TypeQuestion/List/List-documentation.md": 1090,
	"./Evaluation/TypeQuestion/List/index": 358,
	"./Evaluation/TypeQuestion/List/index.js": 358,
	"./ExternalAuth": 175,
	"./ExternalAuth/": 175,
	"./ExternalAuth/ExternalAuth-documentation.md": 1091,
	"./ExternalAuth/index": 175,
	"./ExternalAuth/index.jsx": 175,
	"./ForgotPassword": 186,
	"./ForgotPassword/": 186,
	"./ForgotPassword/ForgotPassword-documentation.md": 1092,
	"./ForgotPassword/index": 186,
	"./ForgotPassword/index.jsx": 186,
	"./Guest": 187,
	"./Guest/": 187,
	"./Guest/Guest-documentation.md": 1093,
	"./Guest/index": 187,
	"./Guest/index.js": 187,
	"./Guest/style.css": 673,
	"./Help/Faq/Create": 359,
	"./Help/Faq/Create/": 359,
	"./Help/Faq/Create/Create-documentation.md": 1094,
	"./Help/Faq/Create/index": 359,
	"./Help/Faq/Create/index.js": 359,
	"./Help/Faq/List": 360,
	"./Help/Faq/List/": 360,
	"./Help/Faq/List/List-documentation.md": 1095,
	"./Help/Faq/List/index": 360,
	"./Help/Faq/List/index.js": 360,
	"./Help/Faq/Show": 361,
	"./Help/Faq/Show/": 361,
	"./Help/Faq/Show/Show-documentation.md": 1096,
	"./Help/Faq/Show/index": 361,
	"./Help/Faq/Show/index.js": 361,
	"./Help/Helpdesk/Category/Create": 362,
	"./Help/Helpdesk/Category/Create/": 362,
	"./Help/Helpdesk/Category/Create/Create-documentation.md": 1097,
	"./Help/Helpdesk/Category/Create/index": 362,
	"./Help/Helpdesk/Category/Create/index.js": 362,
	"./Help/Helpdesk/Category/List": 363,
	"./Help/Helpdesk/Category/List/": 363,
	"./Help/Helpdesk/Category/List/List-documentation.md": 1098,
	"./Help/Helpdesk/Category/List/index": 363,
	"./Help/Helpdesk/Category/List/index.js": 363,
	"./Help/Helpdesk/List": 364,
	"./Help/Helpdesk/List/": 364,
	"./Help/Helpdesk/List/List-documentation.md": 1099,
	"./Help/Helpdesk/List/index": 364,
	"./Help/Helpdesk/List/index.js": 364,
	"./Help/Helpdesk/List/style.css": 755,
	"./Help/Helpdesk/Me": 365,
	"./Help/Helpdesk/Me/": 365,
	"./Help/Helpdesk/Me/Me-documentation.md": 1100,
	"./Help/Helpdesk/Me/index": 365,
	"./Help/Helpdesk/Me/index.js": 365,
	"./Help/Helpdesk/Me/style.css": 756,
	"./Help/Helpdesk/Show": 366,
	"./Help/Helpdesk/Show/": 366,
	"./Help/Helpdesk/Show/Show-documentation.md": 1101,
	"./Help/Helpdesk/Show/index": 366,
	"./Help/Helpdesk/Show/index.js": 366,
	"./Help/Helpdesk/Show/style.css": 757,
	"./Help/Tutorials": 408,
	"./Help/Tutorials/": 408,
	"./Help/Tutorials/Tutorials-documentation.md": 1102,
	"./Help/Tutorials/index": 408,
	"./Help/Tutorials/index.jsx": 408,
	"./Import": 409,
	"./Import/": 409,
	"./Import/Import-documentation.md": 1103,
	"./Import/ImportAllocateStudents": 367,
	"./Import/ImportAllocateStudents/": 367,
	"./Import/ImportAllocateStudents/index": 367,
	"./Import/ImportAllocateStudents/index.js": 367,
	"./Import/ImportAllocateStudents/style.css": 758,
	"./Import/Students": 368,
	"./Import/Students/": 368,
	"./Import/Students/index": 368,
	"./Import/Students/index.js": 368,
	"./Import/Students/style.css": 759,
	"./Import/index": 409,
	"./Import/index.js": 409,
	"./Import/indexLegacy": 586,
	"./Import/indexLegacy.js": 586,
	"./Import/style.css": 585,
	"./LessonPlans": 369,
	"./LessonPlans/": 369,
	"./LessonPlans/View": 410,
	"./LessonPlans/View/": 410,
	"./LessonPlans/View/index": 410,
	"./LessonPlans/View/index.jsx": 410,
	"./LessonPlans/index": 369,
	"./LessonPlans/index.jsx": 369,
	"./Login": 188,
	"./Login/": 188,
	"./Login/Login-documentation.md": 1104,
	"./Login/LoginExternal": 470,
	"./Login/LoginExternal.jsx": 470,
	"./Login/index": 188,
	"./Login/index.js": 188,
	"./Logout": 189,
	"./Logout/": 189,
	"./Logout/Logout-documentation.md": 1105,
	"./Logout/index": 189,
	"./Logout/index.js": 189,
	"./Logs": 411,
	"./Logs/": 411,
	"./Logs/Logs-documentation.md": 1106,
	"./Logs/index": 411,
	"./Logs/index.js": 411,
	"./Management": 412,
	"./Management/": 412,
	"./Management/Management-documentation.md": 1107,
	"./Management/index": 412,
	"./Management/index.js": 412,
	"./Management/style.scss": 587,
	"./Management/toRemove": 588,
	"./Management/toRemove.js": 588,
	"./News/Panel": 413,
	"./News/Panel/": 413,
	"./News/Panel/Panel-documentation.md": 1108,
	"./News/Panel/index": 413,
	"./News/Panel/index.jsx": 413,
	"./Offline/Register/Create": 370,
	"./Offline/Register/Create/": 370,
	"./Offline/Register/Create/Create-documentation.md": 1109,
	"./Offline/Register/Create/index": 370,
	"./Offline/Register/Create/index.jsx": 370,
	"./Offline/Register/Create/style.css": 760,
	"./Offline/Register/Edit": 371,
	"./Offline/Register/Edit/": 371,
	"./Offline/Register/Edit/Edit-documentation.md": 1110,
	"./Offline/Register/Edit/index": 371,
	"./Offline/Register/Edit/index.jsx": 371,
	"./Offline/Register/Edit/styles.css": 1111,
	"./Offline/Register/List": 414,
	"./Offline/Register/List/": 414,
	"./Offline/Register/List/List-documentation.md": 1112,
	"./Offline/Register/List/index": 414,
	"./Offline/Register/List/index.jsx": 414,
	"./Offline/Register/List/styles.css": 1113,
	"./Offline/Register/View": 372,
	"./Offline/Register/View/": 372,
	"./Offline/Register/View/View-documentation.md": 1114,
	"./Offline/Register/View/index": 372,
	"./Offline/Register/View/index.jsx": 372,
	"./Olympics/Activity": 373,
	"./Olympics/Activity/": 373,
	"./Olympics/Activity/index": 373,
	"./Olympics/Activity/index.jsx": 373,
	"./Olympics/Conecta.png": 423,
	"./Olympics/Dashboard": 415,
	"./Olympics/Dashboard/": 415,
	"./Olympics/Dashboard/index": 415,
	"./Olympics/Dashboard/index.js": 415,
	"./Olympics/Dashboard/styles.css": 761,
	"./Olympics/Leaderboard/School": 374,
	"./Olympics/Leaderboard/School/": 374,
	"./Olympics/Leaderboard/School/index": 374,
	"./Olympics/Leaderboard/School/index.js": 374,
	"./Olympics/Leaderboard/Student": 375,
	"./Olympics/Leaderboard/Student/": 375,
	"./Olympics/Leaderboard/Student/index": 375,
	"./Olympics/Leaderboard/Student/index.js": 375,
	"./Olympics/List": 376,
	"./Olympics/List/": 376,
	"./Olympics/List/index": 376,
	"./Olympics/List/index.js": 376,
	"./PDF": 390,
	"./PDF/": 390,
	"./PDF/PDF-documentation.md": 1116,
	"./PDF/index": 390,
	"./PDF/index.jsx": 390,
	"./PedagogicalFollowUps": 416,
	"./PedagogicalFollowUps/": 416,
	"./PedagogicalFollowUps/Allocate": 377,
	"./PedagogicalFollowUps/Allocate/": 377,
	"./PedagogicalFollowUps/Allocate/index": 377,
	"./PedagogicalFollowUps/Allocate/index.jsx": 377,
	"./PedagogicalFollowUps/Consolidated": 378,
	"./PedagogicalFollowUps/Consolidated/": 378,
	"./PedagogicalFollowUps/Consolidated/index": 378,
	"./PedagogicalFollowUps/Consolidated/index.jsx": 378,
	"./PedagogicalFollowUps/Consolidated/newConsolidated": 379,
	"./PedagogicalFollowUps/Consolidated/newConsolidated/": 379,
	"./PedagogicalFollowUps/Consolidated/newConsolidated/index": 379,
	"./PedagogicalFollowUps/Consolidated/newConsolidated/index.jsx": 379,
	"./PedagogicalFollowUps/Consolidated/newConsolidated/styles.css": 763,
	"./PedagogicalFollowUps/Consolidated/styles.css": 762,
	"./PedagogicalFollowUps/Create": 417,
	"./PedagogicalFollowUps/Create/": 417,
	"./PedagogicalFollowUps/Create/index": 417,
	"./PedagogicalFollowUps/Create/index.jsx": 417,
	"./PedagogicalFollowUps/Execution": 380,
	"./PedagogicalFollowUps/Execution/": 380,
	"./PedagogicalFollowUps/Execution/Room": 381,
	"./PedagogicalFollowUps/Execution/Room/": 381,
	"./PedagogicalFollowUps/Execution/Room/index": 381,
	"./PedagogicalFollowUps/Execution/Room/index.jsx": 381,
	"./PedagogicalFollowUps/Execution/Room/styles.css": 765,
	"./PedagogicalFollowUps/Execution/index": 380,
	"./PedagogicalFollowUps/Execution/index.jsx": 380,
	"./PedagogicalFollowUps/Execution/styles.css": 764,
	"./PedagogicalFollowUps/List": 382,
	"./PedagogicalFollowUps/List/": 382,
	"./PedagogicalFollowUps/List/index": 382,
	"./PedagogicalFollowUps/List/index.jsx": 382,
	"./PedagogicalFollowUps/index": 416,
	"./PedagogicalFollowUps/index.jsx": 416,
	"./PendingLOs/List": 398,
	"./PendingLOs/List/": 398,
	"./PendingLOs/List/List-documentation.md": 1117,
	"./PendingLOs/List/index": 398,
	"./PendingLOs/List/index.jsx": 398,
	"./Profile": 399,
	"./Profile/": 399,
	"./Profile/Profile-documentation.md": 1118,
	"./Profile/SummaryStudent": 383,
	"./Profile/SummaryStudent/": 383,
	"./Profile/SummaryStudent/index": 383,
	"./Profile/SummaryStudent/index.jsx": 383,
	"./Profile/SummaryStudent/styles.css": 767,
	"./Profile/index": 399,
	"./Profile/index.js": 399,
	"./Profile/styles.css": 766,
	"./Report/Access": 384,
	"./Report/Access/": 384,
	"./Report/Access/Access-documentation.md": 1119,
	"./Report/Access/index": 384,
	"./Report/Access/index.jsx": 384,
	"./Report/Trails": 385,
	"./Report/Trails/": 385,
	"./Report/Trails/index": 385,
	"./Report/Trails/index.jsx": 385,
	"./Report/Trails/styles.css": 768,
	"./Root": 480,
	"./Root.js": 480,
	"./Stift/View": 418,
	"./Stift/View/": 418,
	"./Stift/View/View-documentation.md": 1120,
	"./Stift/View/index": 418,
	"./Stift/View/index.js": 418,
	"./Tools/Gerador/Create": 386,
	"./Tools/Gerador/Create/": 386,
	"./Tools/Gerador/Create/Create-documentation.md": 1121,
	"./Tools/Gerador/Create/index": 386,
	"./Tools/Gerador/Create/index.jsx": 386,
	"./Tools/Gerador/Gerador-documentation.md": 1122,
	"./Tools/Gerador/List": 387,
	"./Tools/Gerador/List/": 387,
	"./Tools/Gerador/List/List-documentation.md": 1123,
	"./Tools/Gerador/List/index": 387,
	"./Tools/Gerador/List/index.jsx": 387,
	"./Tools/Gerador/Show": 388,
	"./Tools/Gerador/Show/": 388,
	"./Tools/Gerador/Show/Show-documentation.md": 1124,
	"./Tools/Gerador/Show/index": 388,
	"./Tools/Gerador/Show/index.jsx": 388,
	"./Tools/Literarte": 392,
	"./Tools/Literarte/": 392,
	"./Tools/Literarte/Literarte-documentation.md": 1125,
	"./Tools/Literarte/index": 392,
	"./Tools/Literarte/index.jsx": 392,
	"./Tools/Newton": 419,
	"./Tools/Newton/": 419,
	"./Tools/Newton/Newton-documentation.md": 1126,
	"./Tools/Newton/index": 419,
	"./Tools/Newton/index.js": 419,
	"./Tools/Newton/style.css": 769,
	"./styles.css": 770
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 834;